"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _antd = require("antd");

require("./PaginationComponent.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var PaginationComponent = function PaginationComponent(_ref) {
  var defaultPageSize = _ref.defaultPageSize,
      total = _ref.total,
      defaultCurrent = _ref.defaultCurrent,
      disabled = _ref.disabled,
      pageSizeOptions = _ref.pageSizeOptions,
      position = _ref.position;
  return /*#__PURE__*/_react["default"].createElement(_antd.Pagination, {
    total: total,
    defaultPageSize: defaultPageSize || 10,
    defaultCurrent: defaultCurrent || 1,
    disabled: disabled || false,
    position: position || "bottomRight",
    pageSizeOptions: pageSizeOptions || [10, 20, 50, 100]
  });
};

var _default = PaginationComponent;
exports["default"] = _default;